"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadMoreCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var LoadingIndicator_1 = require("../../atoms/LoadingIndicator");
var styles_1 = __importDefault(require("./styles"));
/**
 * Load more card with built in intersection observer
 * * Use when boolean flag to prevent/allow onIntersection callbacks
 * * Provide optional loading flag to display loading indicator
 * * Provide optional message for context to the user, if needed
 */
exports.LoadMoreCard = react_1.default.memo(function (_a) {
    var when = _a.when, loading = _a.loading, message = _a.message, _b = _a.onIntersection, onIntersection = _b === void 0 ? function () { } : _b, _c = _a.intersectionOptions, intersectionOptions = _c === void 0 ? {
        root: null,
        rootMargin: '0px',
        threshold: 0,
    } : _c;
    var ref = react_1.default.createRef();
    var classes = (0, styles_1.default)();
    var handleIntersection = react_1.default.useCallback(function (entries, observer) {
        if (when) {
            var entry = entries[0];
            if (entry.isIntersecting) {
                onIntersection(entries, observer);
            }
        }
    }, [onIntersection, when]);
    var observer = react_1.default.useMemo(function () { return new IntersectionObserver(handleIntersection, intersectionOptions); }, [handleIntersection, intersectionOptions]);
    react_1.default.useEffect(function () {
        var refTrace = ref.current;
        if (refTrace)
            observer.observe(refTrace);
        return function () {
            if (refTrace)
                observer.unobserve(refTrace);
        };
    }, [ref, observer]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ ref: ref, className: classes.root }, { children: [(0, jsx_runtime_1.jsx)(LoadingIndicator_1.LoadingIndicator, { textAlign: "center", loading: loading }), loading && ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ textAlign: "center", padding: 6 }, { children: message })))] })));
});
